import { valueOf } from "@/types/common";

export const USER_TYPE = {
  ADMIN: "admin",
  ADMIN_MEMBER: "admin_member",
  RSO_USER: "rso_user",
};

export type TUserType = valueOf<typeof USER_TYPE>;

export const USER_ACTIVE_STATUS = {
  ACTIVE: "active",
  INACTIVE: "inactice",
};

export const ADMIN_ROLE = {
  MANAGER: "manager",
  SALE: "company_sale",
  CUSTOM_SERVICE: "custom_service",
  AUDITOR: "auditor",
};

export type TAdminRole = valueOf<typeof ADMIN_ROLE>;

export const SUPPORT_IMPLEMENTATION_STATUS = {
  SUPPORTED: "supported",
  NOT_SUPPORTED: "not_supported",
  NO_PARTICIPANT: "no_participant",
};

export const RESIDENCE_STATUS = {
  SPECIFIED_SKILL_NO1: 1,
  SPECIFIED_SKILL_NO2: 2,
  SPECIFIED_ACTIVITY: 3,
} as const;

export const RETIREMENT_STATUS = {
  ENROLLMENT: "enrollment",
  PROCESSING: "processing",
  RETIRED: "retired",
};

export enum EProductCode {
  VISA = "visa",
  ACCOUNT = "account",
  // TODO: [match-phase] Restore MATCH when match integration is implemented.
  // MATCH = "match",
  STUDY = "study",
  CENTER = "center",
}

export enum EContractStatus {
  DURING_CONTRACT = "during_contract",
  CANCELED_CONTRACT = "canceled_contract",
  TRIAL = "trial",
  TRIAL_CANCELLED = "trial_cancelled",
  DELETED_CONTRACT = "deleted_contract",
}
